import { BaseFilterListRequestModel } from "api/baseFilterListModel/BaseFilterListRequestModel";

export class NumberTypeListRequestModel extends BaseFilterListRequestModel {
  code?: string;
  limit?: number;
  name?: string;
  page?: number;

  constructor(data?: {
    code?: string;
    limit?: number;
    name?: string;
    page?: number;
  }) {
    super();
    this.code = data?.code;
    this.limit = data?.limit;
    this.name = data?.name;
    this.page = data?.page;
  }
}
